/**
 * Route for `payout-threshold-enforcement-min-balance-before-re`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PayoutThresholdEnforcementMinBalanceBeforeRePage } from "../features/payout-threshold-enforcement-min-balance-before-re/PayoutThresholdEnforcementMinBalanceBeforeRePage";

export const payoutThresholdEnforcementMinBalanceBeforeReRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/payout-threshold-enforcement-min-balance-before-re",
	component: PayoutThresholdEnforcementMinBalanceBeforeRePage,
});

export default payoutThresholdEnforcementMinBalanceBeforeReRoute;
